import { spacingVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { style } from '@vanilla-extract/css';
import { filterOptionRowClass } from '../../filter-panel.css';

const LOADER_CONTAINER_HEIGHT_PX = 50;

export const selectPaginatedFilterClass = style({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0,
  padding: spacingVars.sm,
});

export const searchClass = style({
  flexShrink: 0,
  marginBottom: spacingVars.lg,
});

export const loaderContainerClass = style({
  height: LOADER_CONTAINER_HEIGHT_PX,
});

export const panelScrollClass = style({
  padding: 0,
});

export const optionRowClass = filterOptionRowClass;

export const noResultsClass = style({
  width: '100%',
  textAlign: 'center',
  padding: `${spacingVars.sm} 0`,
  color: semanticTokenVars.content.placeholder.default,
});
